// hooks/useLobby.js
import { useContext } from 'react';
import { LobbySocketContext } from '@api/socket.js';

export function useLobby() {
    const socket = useContext(LobbySocketContext);

    const joinLobby = ({ lobbyCode, name, persistentId, password }) =>
        new Promise((res) => {
            socket.emit('joinLobby', {
                lobbyCode,
                user:{
                    name,
                    persistentId
                },
                password
            }, res);
        });

    const reconnect = ({ lobbyCode, persistentId }) =>
        new Promise((res) => {
            if (!socket.connected) socket.connect();
            socket.emit('reconnectToLobby', { lobbyCode, persistentId }, res);
        });

    return { socket, joinLobby, reconnect };
}
